<template>
  <pt-doctor-table class="pt-doctor-table__page"></pt-doctor-table>
</template>

<script>
import PtDoctorTable from 'cps/hospital-and-doctor-manage/pt-doctor-manage/pt-doctor-table/withData'
export default {
  name: 'pt-doctor-table__view',
  components: {
    'pt-doctor-table': PtDoctorTable
  }
}
</script>
